module.exports = {"name":"ContentOptimization","parameters":[{"name":"renderNewEnterpriseTable","value":false},{"name":"enableAIGeneratedItems","value":false}]}